import { render, staticRenderFns } from "./GAResetPage.vue?vue&type=template&id=65cfd7b6&scoped=true"
import script from "./GAResetPage.vue?vue&type=script&lang=ts"
export * from "./GAResetPage.vue?vue&type=script&lang=ts"
import style0 from "./GAResetPage.vue?vue&type=style&index=0&id=65cfd7b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cfd7b6",
  null
  
)

export default component.exports